// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__Yq-Nz","active":"Navigation_active__DLowT","newlink":"Navigation_newlink__iNzkc","newactive":"Navigation_newactive__Yhmoz"};